var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.553,12.667h6.333c3.182,0,3.753-1.275,3.919-2.826L15.4,3.507C15.612,1.575,15.058,0,11.678,0H3.761C.381,0-.174,1.575.04,3.507L.634,9.84C.8,11.392,1.37,12.667,4.553,12.667Z",
    transform: "translate(109.781 192.75)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,3.167V2.533C0,1.132,0,0,2.533,0H3.8C6.333,0,6.333,1.132,6.333,2.533v.633",
    transform: "translate(114.333 189.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.167.792V1.6c0,.863-.008,1.567-1.583,1.567S0,2.47,0,1.607V.792C0,0,0,0,.792,0H2.375C3.167,0,3.167,0,3.167.792Z",
    transform: "translate(115.917 197.5)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.056,0A13.05,13.05,0,0,1,0,2.391",
    transform: "translate(119.083 196.708)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0A12.891,12.891,0,0,0,5.843,2.185",
    transform: "translate(110.074 196.922)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    transform: "translate(127 207) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareers);
export default __webpack_public_path__ + "static/media/careers.eae4b1b8fa837d6da8ae972df8b0e59c.svg";
export { ForwardRef as ReactComponent };